import emptyState from "./SecurityQuestionsEmptyState";
import { actionTypes as actionTypesChangePwd } from "../../pages/ChangePassword/module/actions";
import { actionTypes as actionTypesResetPwd } from "../../pages/ResetPassword/module/actions";
import { actionTypes as actionTypesChangeMobile } from "../../common/TwoFactorAuth/module/actions";
import { immutableSet } from "../../utils/immutable";
import { IAction } from "../../models/Action";
import { compose } from "redux";

import {
  STATE_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./SecurityQuestionsConstants";
import { IResponseState } from "../../components/Modals/ResponseModal/module/constants";

const { QUESTIONS, QUESTIONS_LOADER, ANSWER, REQUEST_STATE } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypesChangePwd.GET_CHANGE_PWD_QUESTIONS]: (state: any, action: any) =>
    immutableSet([QUESTIONS_LOADER], true, state),
  [actionTypesChangePwd.GET_CHANGE_PWD_QUESTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([QUESTIONS], action.payload),
      immutableSet([QUESTIONS_LOADER], false)
    )(state);
  },
  [actionTypesChangePwd.GET_CHANGE_PWD_QUESTIONS_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([QUESTIONS], []),
      immutableSet([QUESTIONS_LOADER], false)
    )(state),

  [actionTypesChangeMobile.GET_CHANGE_MOBILE_SEC_QUESTIONS]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypesChangeMobile.GET_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([QUESTIONS], action.payload),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypesChangeMobile.GET_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([QUESTIONS], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),

  [actionTypesChangePwd.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypesChangePwd.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypesChangePwd.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypesChangePwd.DISPATCH_CHANGE_PWD_ANSWER]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [QUESTIONS, action.payload.index, ANSWER],
      action.payload.answer,
      state
    ),
  [actionTypesResetPwd.GET_RESET_PWD_QUESTIONS]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypesResetPwd.GET_RESET_PWD_QUESTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([QUESTIONS], action.payload),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypesResetPwd.GET_RESET_PWD_QUESTIONS_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([QUESTIONS], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/change-password/step-two" ||
      action.payload.location.pathname === "/reset-password/step-two")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
